type ExportedNodeIdentity = { copyReferenceId: string | null | undefined }

// KBE-516: copyReferenceId is the cross-system node-identity contract that
// Ancestra Health content links depend on. The exported network.json must
// carry a non-null, network-unique id for every node. This is the export-time
// guard mirroring the DB UNIQUE(network_id, copy_reference_id) constraint.
export function assertNodeIdentityContract(
  nodes: Record<string, ExportedNodeIdentity>,
): void {
  const seenIdToName = new Map<string, string>()
  for (const [name, node] of Object.entries(nodes)) {
    if (!node.copyReferenceId) {
      throw new Error(
        `Exported node "${name}" has no copyReferenceId. Every node must carry a stable node id (KBE-516).`,
      )
    }
    const existingName = seenIdToName.get(node.copyReferenceId)
    if (existingName) {
      throw new Error(
        `Exported nodes "${existingName}" and "${name}" share copyReferenceId ${node.copyReferenceId}. Node ids must be unique within a network (KBE-516).`,
      )
    }
    seenIdToName.set(node.copyReferenceId, name)
  }
}
